import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressMembersFollowV3MemberFollowersUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www.wixapis.com': [
      {
        srcPath: '/members/v3/followers',
        destPath: '/v3/followers',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/members/v3/followers',
        destPath: '/v3/followers',
      },
      {
        srcPath: '/members/v3/followers',
        destPath: '/v3/followers',
      },
    ],
    _: [
      {
        srcPath: '/_api/members/v3/followers',
        destPath: '/v3/followers',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/members/v3/followers',
        destPath: '/v3/followers',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/members/v3/followers',
        destPath: '/v3/followers',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/members/v3/followers',
        destPath: '/v3/followers',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/members/v3/followers',
        destPath: '/v3/followers',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/members/v3/followers',
        destPath: '/v3/followers',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_members_member-followers';

/** Sets the current member to follow another, specified member. */
export function followMember(payload: object): RequestOptionsFactory<any> {
  function __followMember({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.members.v3.follow',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.members.follow.v3.MemberFollowers.FollowMember',
      packageName: PACKAGE_NAME,
      url: resolveComWixpressMembersFollowV3MemberFollowersUrl({
        protoPath: '/v3/followers/{memberId}',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __followMember;
}

/** Sets the current member to unfollow another, specified member. */
export function unfollowMember(payload: object): RequestOptionsFactory<any> {
  function __unfollowMember({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.members.v3.follow',
      method: 'DELETE' as any,
      methodFqn:
        'com.wixpress.members.follow.v3.MemberFollowers.UnfollowMember',
      packageName: PACKAGE_NAME,
      url: resolveComWixpressMembersFollowV3MemberFollowersUrl({
        protoPath: '/v3/followers/{memberId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __unfollowMember;
}

/** Retrieves a list of members who are followed by the current member. */
export function listMyMemberFollowing(
  payload: object
): RequestOptionsFactory<any> {
  function __listMyMemberFollowing({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.members.v3.follow',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.members.follow.v3.MemberFollowers.ListMyMemberFollowing',
      packageName: PACKAGE_NAME,
      url: resolveComWixpressMembersFollowV3MemberFollowersUrl({
        protoPath: '/v3/followers/my/following',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __listMyMemberFollowing;
}

/** Retrieves a list of members who are followed by the given member. */
export function listMemberFollowing(
  payload: object
): RequestOptionsFactory<any> {
  function __listMemberFollowing({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.members.v3.follow',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.members.follow.v3.MemberFollowers.ListMemberFollowing',
      packageName: PACKAGE_NAME,
      url: resolveComWixpressMembersFollowV3MemberFollowersUrl({
        protoPath: '/v3/followers/{memberId}/following',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __listMemberFollowing;
}

/** Retrieves a list of members who are following the current member. */
export function listMyMemberFollowers(
  payload: object
): RequestOptionsFactory<any> {
  function __listMyMemberFollowers({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.members.v3.follow',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.members.follow.v3.MemberFollowers.ListMyMemberFollowers',
      packageName: PACKAGE_NAME,
      url: resolveComWixpressMembersFollowV3MemberFollowersUrl({
        protoPath: '/v3/followers/my',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __listMyMemberFollowers;
}

/** Retrieves a list of members who are following the given member. */
export function listMemberFollowers(
  payload: object
): RequestOptionsFactory<any> {
  function __listMemberFollowers({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.members.v3.follow',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.members.follow.v3.MemberFollowers.ListMemberFollowers',
      packageName: PACKAGE_NAME,
      url: resolveComWixpressMembersFollowV3MemberFollowersUrl({
        protoPath: '/v3/followers/{memberId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __listMemberFollowers;
}

/** Retrieves a list of members and their connections to the current member. */
export function queryMyMemberConnections(
  payload: object
): RequestOptionsFactory<any> {
  function __queryMyMemberConnections({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.members.v3.follow',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.members.follow.v3.MemberFollowers.QueryMyMemberConnections',
      packageName: PACKAGE_NAME,
      url: resolveComWixpressMembersFollowV3MemberFollowersUrl({
        protoPath: '/v3/followers/my/connections',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __queryMyMemberConnections;
}

/**
 * Retrieves a list of members and their connections to the given member.
 * > **Note:** If an empty array is passed as `connectedMemberIds`, the call will succeed, but it will not return any data.
 */
export function queryMemberConnections(
  payload: object
): RequestOptionsFactory<any> {
  function __queryMemberConnections({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.members.v3.follow',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.members.follow.v3.MemberFollowers.QueryMemberConnections',
      packageName: PACKAGE_NAME,
      url: resolveComWixpressMembersFollowV3MemberFollowersUrl({
        protoPath: '/v3/followers/{memberId}/connections',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __queryMemberConnections;
}
